// extracted by mini-css-extract-plugin
export default {"popup":"Button_popup__2iwZA","fullscreen":"Button_fullscreen__EOykr"};